/**
 * Session de l'utilisateur connecté.
 *
 * Le rôle dit **ce que fait** l'utilisateur (`expert`, `superviseur`,
 * `super-admin`) ; l'organisation dit **pour qui**. Les écrans qui distinguaient
 * un agent RMA d'un expert VeoSmart le faisaient en lisant le libellé du rôle
 * (`role.includes("rma")`) — ce n'est plus possible et ce n'était plus juste :
 * la vraie question est « côté client ou côté staff ? », donc `is_staff`.
 */

export const ROLE_SUPER_ADMIN = 'super-admin';
export const ROLE_EXPERT = 'expert';
export const ROLE_SUPERVISEUR = 'superviseur';

export const getUserRole = () => localStorage.getItem('user_role') || '';

/**
 * Session ouverte avec le login actuel. `is_staff` est toujours écrit au login
 * ('true' ou 'false') : son absence signale une session ouverte avant le passage
 * aux organisations, que le front lirait à tort comme une session client.
 */
export const isCurrentSession = () =>
  Boolean(localStorage.getItem('access_token')) && localStorage.getItem('is_staff') !== null;

/** `exp` du JWT dépassé ? Un jeton illisible ou sans `exp` n'est pas considéré expiré. */
export const isTokenExpired = () => {
  try {
    const payload = JSON.parse(atob(localStorage.getItem('access_token').split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return typeof payload.exp === 'number' && payload.exp * 1000 <= Date.now();
  } catch {
    return false;
  }
};

export const getOrganisationId = () => {
  const raw = localStorage.getItem('organisation_id');
  return raw ? Number(raw) : null;
};

export const getOrganisationName = () => localStorage.getItem('organisation_name') || '';

/** Utilisateur de l'organisation interne (VeoSmart) : il produit les rapports. */
export const isStaffUser = () => localStorage.getItem('is_staff') === 'true';

/** Utilisateur d'une organisation cliente (RMA, Sanlam...) : il valide. */
export const isClientOrgUser = () => !isStaffUser();

export const isSuperAdmin = () => getUserRole() === ROLE_SUPER_ADMIN;

/** Droits de supervision : superviseur, ou super-admin qui les englobe. */
export const isSupervisor = () =>
  [ROLE_SUPER_ADMIN, ROLE_SUPERVISEUR].includes(getUserRole());
